import arrayPush from "./component-library389.mjs";
import isArray from "./component-library293.mjs";
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
export {
  baseGetAllKeys as default
};
